import axios from '@/app/axios'
import PaginationResponse from '@/common/pagination/entities/pagination-response'
import HistoryEntry from '../models/HistoryEntry'
import Responses from '@/app/utils/responses'
import HistoryFilter from '../models/HistoryFilter'

class HistoryService {
  public async findAllProductiveAsync(request: HistoryFilter) {
    const res = await axios.post<PaginationResponse<HistoryEntry>>(
      `history`,
      request.paging
    )
    return Responses.pagedList(res)
  }
}

export default new HistoryService()